export default __webpack_public_path__ + "static/media/red.39f98619.png";